var enable_cart_ignore = true;
var ignoreList = ["RoasterCup"];
var inCartVendors = window.cartLimitSettings?.inCartVendors || [];
inCartVendors = inCartVendors.filter(function (v) {
  return !ignoreList.includes(v);
});
inCartVendors = Array.from(new Set(inCartVendors));

const max_allowed_vendor = window.cartLimitSettings?.maxVendor || 3;
const limit_title = window.cartLimitSettings?.title || "Cart Limit Reached";
const limit_html = window.cartLimitSettings?.subtitle || "Please remove items to continue";
const limit_btn_text = window.cartLimitSettings?.buttonText || "OK";

function openAlert() {
  if (typeof Swal !== "undefined") {
    Swal.fire({
      title: limit_title,
      html: limit_html,
      confirmButtonText: limit_btn_text,
      confirmButtonColor: "#9cf644",
    });
  }
}

(function () {
  window.setupCartLimit = function () {
    fetch("/cart.json")
      .then((response) => response.json())
      .then((response) => {
        var vendor = response.items.map(function (item) {
          return item.vendor;
        });
        vendor = vendor.filter(function (v) {
          return !ignoreList.includes(v);
        });
        inCartVendors = Array.from(new Set(vendor));
        if (vendor.length >= max_allowed_vendor) {
          document.querySelector("body").classList.add("limit-reached");
          console.log(`Limit Reached: ${vendor.length}`);
        } else {
          document.querySelector("body").classList.remove("limit-reached");
        }
      });
  };

  class MyCustomElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
    }
    connectedCallback() {
      this.onLoad();
    }
    onLoad() {
      setupCartLimit();
    }
  }

  customElements.define("custom-cart-limit-loader", MyCustomElement);

  // Run on load
  setupCartLimit();

  // Cart removal logic
  var unique_brand_count = max_allowed_vendor;

  fetch("/cart.js")
    .then((res) => res.json())
    .then(async (cart) => {
      const items = cart.items;
      const filteredItems = items.filter((item) => !ignoreList.includes(item.vendor));

      const brandMap = {};
      filteredItems.forEach((item) => {
        if (!brandMap[item.vendor]) {
          brandMap[item.vendor] = [];
        }
        brandMap[item.vendor].push(item);
      });

      const uniqueBrands = Object.keys(brandMap);

      if (uniqueBrands.length > unique_brand_count) {
        const brandsToKeep = uniqueBrands.slice(0, unique_brand_count);
        const brandsToRemove = uniqueBrands.filter((brand) => !brandsToKeep.includes(brand));
        console.log(`Brands to keep: ${brandsToKeep.join(", ")}`);
        console.log(`Brands to Remove: ${brandsToRemove.join(", ")}`);

        const removalPromises = [];

        brandsToRemove.forEach((brand) => {
          brandMap[brand].forEach((item) => {
            removalPromises.push(
              fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0,
                }),
              }),
            );
          });
        });

        await Promise.all(removalPromises);
        console.log(`Removed items from brands: ${brandsToRemove.join(", ")}`);
        location.reload();
      } else {
        console.log(`No action needed. Cart has ${unique_brand_count} or fewer unique brands.`);
      }
    })
    .catch((error) => console.error("Cart processing error:", error));
})();
